module.exports = __webpack_public_path__ + "img/temperature.72b13e61.svg";